const http = require('../lib/httpClient');
const { OTP, COMMERCE_HEADER, SESSION_STORAGE } = require('../constants');
const {
  getChannelId,
  getEcommId,
  getXCommerceValue,
  getItemInSessionStorage,
  removeItemInSessionStorage,
} = require('../lib/browserData');

const catalystOtpValidationByError = {
  code: 'CATALYST_GET_OTP_CHALLENGE_VALIDATION_ERROR',
  message: 'Unable to validate otp',
};

const endpoint = '/s/auth/v1/otp/challenge/validation';
const operationType = OTP.OPERATION_TYPE.OTP_NEW_REGISTERED_DEVICE;

async function catalystOtpChallengeValidation(
  tenantId,
  challengeId,
  otp,
  catalystBaseUrl = '',
  isEmailFlow = false,
  otpFlow = false,
) {
  const challengeType = isEmailFlow ? 'email' : 'sms';
  const isDeviceRecognised = getItemInSessionStorage(SESSION_STORAGE.IS_DEVICE_RECOGNISED);
  const fAuthDeviceId = getItemInSessionStorage(SESSION_STORAGE.F_AUTH_DEVICE_ID);
  const userData = JSON.parse(getItemInSessionStorage(SESSION_STORAGE.USER_DATA));

  const { sessionId } = userData;

  const result = await http.post(
    `${catalystBaseUrl}${endpoint}`,
    { operationType, challengeType, challengeId, otp },
    {
      otpFlow,
      headers: {
        'x-channel-id': getChannelId(),
        'x-ecomm-name': getEcommId(tenantId),
        authorization: sessionId,
        'x-f-auth-device-recognized': isDeviceRecognised,
        'x-f-auth-device-id': fAuthDeviceId,
        'x-commerce': getXCommerceValue(catalystBaseUrl) || COMMERCE_HEADER,
      },
    },
  );
  const { responseBody } = result || {};

  if (!responseBody) return { data: undefined, errors: [catalystOtpValidationByError] };
  const { success, errors } = responseBody;
  if (errors) return { data: undefined, errors };
  if (!success) {
    return {
      data: undefined,
      errors: [catalystOtpValidationByError],
    };
  }
  removeItemInSessionStorage(SESSION_STORAGE.IS_DEVICE_RECOGNISED);
  removeItemInSessionStorage(SESSION_STORAGE.F_AUTH_DEVICE_ID);
  return { data: { success }, errors: [] };
}

module.exports = catalystOtpChallengeValidation;
